__turbopack_context__.v({
  "infoTileWrapper": "_L3GZq_infoTileWrapper",
  "infoboxHeadline": "_L3GZq_infoboxHeadline",
  "wrapper": "_L3GZq_wrapper",
});
